module.exports = __webpack_public_path__ + "static/ASME-f5d84769006be78cd2f7495b0a8f08d1.png";